import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import moment from 'moment';

export function GetFilterCollection(currentUserId: number): { text: string; value: CompositeFilterDescriptor | null }[] {
  return [
    { text: 'No Filter', value: null },
    {
      text: 'Created By Me Assigned to Others',
      value: {
        logic: 'and',
        filters: [
          { field: 'createdByCompanyUserId', value: currentUserId, operator: 'eq' },
          { field: 'assignedTo', value: currentUserId, operator: 'neq' },
        ],
      },
    },
    {
      text: 'Assigned to Me Created by Others',
      value: {
        logic: 'and',
        filters: [
          { field: 'createdByCompanyUserId', value: currentUserId, operator: 'neq' },
          { field: 'assignedTo', value: currentUserId, operator: 'eq' },
        ],
      },
    },
    {
      text: 'Past Due and Not Complete',
      value: {
        logic: 'and',
        filters: [
          { field: 'dueDate', value: new Date(), operator: 'lt' },
          { field: 'isComplete', value: false, operator: 'eq' },
        ],
      },
    },
    {
      text: 'Due In Next 7 Days',
      value: {
        logic: 'and',
        filters: [
          {
            filters: [
              { field: 'dueDate', value: new Date(), operator: 'gte' },
              { field: 'dueDate', value: moment().add(7, 'days').toDate(), operator: 'lte' },
            ],
            logic: 'and',
          },
        ],
      },
    },
    {
      text: 'Created Last 7 days',
      value: {
        logic: 'and',
        filters: [
          {
            filters: [
              { field: 'createdDate', value: moment().subtract(7, 'days').toDate(), operator: 'gte' },
              { field: 'createdDate', value: new Date(), operator: 'lte' },
            ],
            logic: 'and',
          },
        ],
      },
    },
    {
      text: 'Created Last 30 days',
      value: {
        logic: 'and',
        filters: [
          {
            filters: [
              { field: 'createdDate', value: moment().subtract(30, 'days').toDate(), operator: 'gte' },
              { field: 'createdDate', value: new Date(), operator: 'lte' },
            ],
            logic: 'and',
          },
        ],
      },
    },
    {
      text: 'Has Responded',
      value: {
        logic: 'and',
        filters: [
          { field: 'didRespond', value: true, operator: 'eq' },
          {
            filters: [
              { field: 'activityType', value: 'Communication', operator: 'eq' },
              { field: 'activityType', value: 'Call', operator: 'eq' },
            ],
            logic: 'or',
          },
        ],
      },
    },
    {
      text: 'Has Not Responded',
      value: {
        logic: 'and',
        filters: [
          { field: 'didRespond', value: false, operator: 'eq' },
          {
            filters: [
              { field: 'activityType', value: 'Communication', operator: 'eq' },
              { field: 'activityType', value: 'Call', operator: 'eq' },
            ],
            logic: 'or',
          },
        ],
      },
    },
    {
      text: 'No Response and Follow-Up passed',
      value: {
        logic: 'and',
        filters: [
          { field: 'didRespond', value: false, operator: 'eq' },
          { field: 'followUpDate', value: new Date(), operator: 'lte' },
          {
            filters: [
              { field: 'activityType', value: 'Communication', operator: 'eq' },
              { field: 'activityType', value: 'Call', operator: 'eq' },
            ],
            logic: 'or',
          },
        ],
      },
    },
    {
      text: 'Follow Up in Next 7 days',
      value: {
        logic: 'and',
        filters: [
          {
            filters: [
              { field: 'followUpDate', value: new Date(), operator: 'gte' },
              { field: 'followUpDate', value: moment().add(7, 'days').toDate(), operator: 'lte' },
            ],
            logic: 'and',
          },
        ],
      },
    },
    {
      text: 'Has Associated Order#',
      value: {
        logic: 'and',
        filters: [
          {
            filters: [{ field: 'orderNumber', value: null, operator: 'ne' }],
            logic: 'and',
          },
        ],
      },
    },
    {
      text: 'Has Attachment',
      value: {
        logic: 'and',
        filters: [
          {
            filters: [{ field: 'totalAttachments', value: 1, operator: 'gte' }],
            logic: 'and',
          },
        ],
      },
    },
  ];
}
